export const getLinkValidationMessageText = (type: string = 'мероприятия') =>
  `Дата создания акта мероприятия, по которому зафиксирована невозможность его проведения, должна быть не позднее 3х месяцев относительно даты начала текущего ${type}`;

export const LinkValidationGeneralMessageText = 'Паспорт не удовлетворяет условиям';

export const LinkValidationReasonImpossibleByControlledPersonActionsErrorMessage =
  'Проведение КНМ в случае невозможности проведения обязательного профвизита допускается только при «В связи с иными действиями (бездействием) контролируемого лица, повлекшими невозможность проведения или завершения контрольного (надзорного), профилактического мероприятия»';

export const LinkValidationPrescriptionMessageText =
  'В паспорте отсутствует подписанное предписание в статусе “Не исполнено”';

export const getLinkedPassportIdsMessageText = (
  response: { linkedPassportIds: { id: number; erpId: string }[] },
  ignoredPassportId?: number,
) =>
  `Ссылка на данное мероприятие уже использована при создании мероприятия: ${response.linkedPassportIds
    .filter(i => i.id !== ignoredPassportId)
    .map(i => `№<a href="/private/knm/${i.id}" target="_blank">${i.erpId}</a>`)
    .join(', ')}`;
